<template>
  <component
    :is="capitalisedIcon"
    v-bind="$props"
  />
</template>

<script>
import Account from './Account';
import Article from './Article';
import Award from './Award';
import Changerequest from './Changerequest';
import Checkbox from './Checkbox';
import Check from './Check';
import Expand from './Expand';
import Fingerprint from './Fingerprint';
import Handshake from './Handshake';
import Help from './Help';
import Lock from './Lock';
import Msa from './Msa';
import GsaNda from './GsaNda';
import Nosound from './Nosound';
import Eye from './Eye';
import Puzzle from './Puzzle';
import Pig from './Pig';
import Play from './Play';
import Send from './Send';
import Sound from './Sound';
import Sow from './Sow';
import Video from './Video';
import Workcategory from './Workcategory';
import Chevronright from './Chevronright';
import Umbrella from './Umbrella';
import Rocket from './Rocket';

export default {
  components: {
    Account,
    Article,
    Award,
    Changerequest,
    Checkbox,
    Check,
    Expand,
    Fingerprint,
    Handshake,
    Help,
    Lock,
    Msa,
    GsaNda,
    Nosound,
    Eye,
    Pig,
    Puzzle,
    Play,
    Send,
    Sound,
    Sow,
    Video,
    Workcategory,
    Chevronright,
    Umbrella,
    Rocket,
  },

  props: {
    icon: {
      type: String,
      required: true,
    },
    width: {
      type: Number,
      default: 15,
    },
    colour: {
      type: String,
      default: 'black',
    },
  },

  computed: {
    capitalisedIcon() {
      return this.icon.replace(/^\w/, (c) => c.toUpperCase());
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
